<template>
	<div style="display: contents;">
		<!-- Trigger: variante toolbar -->
		<template v-if="buttonComponent == 'v-btn'">
			<v-tooltip top>
				<template v-slot:activator="{ on: tooltip }">
					<v-btn
						v-on="{ ...tooltip }"
						icon
						:disabled="disabled"
						:color="button.color || ''"
						@click="openDialog"
					>
						<v-icon>{{ button.icon || 'payments' }}</v-icon>
					</v-btn>
				</template>
				<span>{{ button.tooltip || 'Genera Abbonamento' }}</span>
			</v-tooltip>
		</template>

		<!-- Trigger: variante dropdown menu -->
		<v-list-item
			v-else-if="buttonComponent == 'v-list-item'"
			dense
			:disabled="disabled"
			@click.stop="openDialog"
			ripple
		>
			<v-list-item-icon>
				<v-icon style="font-size: 18px">{{ button.icon || 'payments' }}</v-icon>
			</v-list-item-icon>
			<v-list-item-content>
				<v-list-item-title>{{ button.tooltip || 'Genera Abbonamento' }}</v-list-item-title>
			</v-list-item-content>
		</v-list-item>

		<!-- Dialog -->
		<v-dialog v-model="dialog" max-width="600" persistent>
			<v-card class="round-card background-1">
				<v-card-title class="pa-3">
					<p class="pl-2 pl-xl-3">{{ button.mainTitle || 'Genera Abbonamento' }}</p>
					<v-spacer></v-spacer>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4 body-2" v-if="button.secondTitle">
					{{ button.secondTitle }}
				</v-card-text>

				<v-container fluid :class="{'px-3': $vuetify.breakpoint.mdAndUp, 'px-0': $vuetify.breakpoint.smAndDown}" class="pt-2" style="min-height: 180px;">
					<div v-if="!loaded" class="d-flex justify-center align-center" style="min-height: 160px;">
						<v-progress-circular indeterminate color="primary"></v-progress-circular>
					</div>
					<fields-generator
						v-else
						:fieldsset.sync="fieldsset"
						:model.sync="formModel"
						ref="fieldsgenerator"
					></fields-generator>
				</v-container>

				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="info" @click="closeDialog">Annulla</v-btn>
					<v-btn text color="primary" @click="submit" :loading="loading">Procedi</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import FormsMixin from '@/mixins/FormsMixin'

export default {
	name: 'generate-subscription-dialog',
	mixins: [FormsMixin],
	props: {
		button: { type: Object, default: () => ({}) },
		params: { type: Object, default: () => ({}) },
		id: { type: [Number, String], default: null },
		model: { type: Object, default: () => ({}) },
		info: { type: Object, default: () => ({}) },
		modelDef: { type: String, default: '' },
		disabled: { type: Boolean, default: false },
		buttonComponent: { type: String, default: 'v-btn' },
	},
	data() {
		return {
			dialog: false,
			loading: false,
			loaded: false,
			fieldsset: {},
			// override locale dei valori del form — popolato al fetch dei fields
			formModel: {},
		}
	},
	methods: {
		openDialog() {
			this.dialog = true
			if (!this.loaded) {
				this.fetchFields()
			}
		},

		closeDialog() {
			this.dialog = false
		},

		fetchFields() {
			const url = this.params.infoUrl || 'info-saleorders-to-subscriptions'
			this.axios.get(url).then(response => {
				this.fieldsset = response.data.fields
				this.loaded = true
				// Popola i default dichiarati dai field
				_.forEach(this.fieldsset.fields, (field) => {
					if (field.default !== undefined && field.key) {
						this.$set(this.formModel, field.key, field.default)
					}
				})
			}).catch(() => {
				this.$store.commit('setSnackbar', {
					timeout: 4000,
					text: 'Errore caricamento campi',
					value: true,
					color: 'error',
				})
			})
		},

		submit() {
			if (!this.id) {
				this.$store.commit('setSnackbar', {
					timeout: 4000,
					text: 'ID ordine mancante',
					value: true,
					color: 'error',
				})
				return
			}

			this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
				if (!result) {
					return this.handleValidationErrorAdvanced()
				}

				this.loading = true
				const submitUrl = (this.params.submitUrl || 'saleorders-subscriptions') + '/' + this.id
				this.axios.post(submitUrl, { model: this.formModel }).then(response => {
					this.loading = false
					this.dialog = false
					this.$store.commit('setSnackbar', {
						timeout: 6000,
						text: 'Abbonamento generato',
						value: true,
						color: 'success',
					})
					const newId = response.data?.id
					const route = this.button.route || this.params.route || 'subscriptions-show'
					if (newId) {
						this.$router.push({ name: route, params: { id: newId } })
					}
				}).catch(error => {
					this.loading = false
					this.$store.commit('setSnackbar', {
						timeout: 5000,
						text: error.response?.data?.message || 'Errore generazione abbonamento',
						value: true,
						color: 'error',
					})
				})
			}).catch(() => {})
		},
	},
}
</script>
